// Web module: risks (lane L8). Drata Risk Assessment register with the overview strip and heatmap, and the risk
// detail tabs (Assessment, Mitigating controls). Overview, Mapped records and History are the generic tabs.
import { lazyComponent } from '../../lib/lazy'
import type { WebModule } from '../../lib/modules'

export const module: WebModule = {
  routes: [],
  entityOverrides: {
    risk: {
      ListPage: lazyComponent(() => import('./RisksListPage'), 'RisksListPage'),
      detailTabs: [
        {
          id: 'assessment',
          label: 'Assessment',
          order: 15,
          component: lazyComponent(() => import('./RiskTabs'), 'RiskAssessmentTab'),
        },
        {
          id: 'controls',
          label: 'Mitigating controls',
          order: 30,
          component: lazyComponent(() => import('./RiskTabs'), 'RiskControlsTab'),
        },
      ],
    },
  },
}
